export default {
  name: 'Nome',
  tel: 'Telefono',
  save: 'Salva',
  confirm: 'Conferma',
  cancel: 'Annulla',
  delete: 'Elimina',
  loading: 'Caricamento in corso...',
  noCoupon: 'Nessun coupon',
  nameEmpty: 'Inserisci il nome',
  addContact: 'Aggiungi contatto',
  telInvalid: 'Numero di telefono errato',
  vanCalendar: {
    end: 'Fine',
    start: 'Inizio',
    title: 'Calendario',
    weekdays: [
      'domenica',
      'Lunedi',
      'Martedì',
      'mercoledì',
      'giovedì',
      'venerdì',
      'Sabato',
    ],
  },
  vanCascader: {
    select: 'Seleziona',
  },
  vanPagination: {
    prev: 'Precedente',
    next: 'Avanti',
  },
  vanPullRefresh: {
    pulling: 'Tiri per aggiornare...',
    loosing: 'Largo per rinfrescare...',
  },
  vanSubmitBar: {
    label: 'Totale:',
  },
  vanCoupon: {
    unlimited: 'Illimitato',
  },
  vanCouponCell: {
    title: 'Buono',
  },
  vanCouponList: {
    exchange: 'Scambio',
    close: 'Chiudi',
    enable: 'Disponibile',
    disabled: 'Non disponibile',
    placeholder: 'Codice coupon',
  },
  vanAddressEdit: {
    area: 'Area',
    postal: 'Postale',
    areaEmpty: "Seleziona un'area di ricezione",
    addressEmpty: "L'indirizzo non può essere vuoto",
    postalEmpty: 'Codice postale errato',
    addressDetail: 'Indirizzo',
    defaultAddress: 'Imposta come indirizzo predefinito',
  },
  vanAddressList: {
    add: 'Aggiungi nuovo indirizzo',
  },
};
